import { IErrorService } from '@pit/core';

export interface IPinItTrackFrontendErrorService extends IErrorService {


}
